import React, { FC } from 'react';
import { Core } from '@everfi/reactifi';
import { useTranslation } from 'react-i18next';

interface Props {
  activePage: number;
  pageSize: number;
  totalCount: number;
}
export const ResultsCount: FC<Props> = ({ activePage, pageSize, totalCount }) => {
  const { t } = useTranslation();
  const resultCountStart = (activePage - 1) * pageSize + 1;
  const resultCountEnd = Math.min(activePage * pageSize, totalCount);
  return (
    <Core.Typography textStyle={'p1'}>
      {t('Results: {{resultCountStart}} - {{resultCountEnd}} of {{totalCount}} ', {
        resultCountStart,
        resultCountEnd,
        totalCount,
      })}
    </Core.Typography>
  );
};
